// extracted by mini-css-extract-plugin
export default {"with-dash":"wm4H0L","withDash":"wm4H0L","semi-bold":"mANmz9","semiBold":"mANmz9"};